* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

gz-form-field {
  --margin-bottom-wrapper: var(--spacer);
}
